export function removeEventFromSchedule(schedule, roundNumber, index) {
  let payload = {...schedule};

  //Remove the entry at position:index from the roundNumber specified
  payload[String(roundNumber)] = payload[String(roundNumber)].filter((d,i) => i !== index);

  return payload
}